<template>
  <v-dialog v-model="dialog" persistent max-width="290">
    <link
      rel="stylesheet"
      href="https://use.fontawesome.com/releases/v5.2.0/css/all.css"
    />
    <v-card :loading="loading">
      <v-card-title class="headline">
        <i
          v-if="type == 'warning'"
          class="fa fa-exclamation-triangle colorWarn"
          aria-hidden="true"
        ></i>
        <i
          v-if="type == 'info'"
          class="fa fa-info-circle colorInfo"
          aria-hidden="true"
        ></i>
        <i
          v-if="type == 'error'"
          class="fa fa-times colorNeg"
          aria-hidden="true"
        ></i>
        <i
          v-if="type == 'question'"
          class="fa fa-question-circle colorInfo"
          aria-hidden="true"
        ></i>
        <v-card-title>{{ heading }}</v-card-title>
      </v-card-title>
      <v-card-text>{{ text }}</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn v-if="hasDismissButton && !loading" text @click="dismiss()"
          >Cancelar</v-btn
        >
        <v-btn v-else-if="loading" text>Cancelar</v-btn>
        <v-btn v-if="!loading" text @click="confirm()">Aceptar</v-btn>
        <v-btn v-else text>Aceptar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      loading: false,
      hasDismissButton: true,
      type: '',
      heading: '',
      title: '',
      text: '',
      onConfirm: () => {
        return new Promise(resolve => {
          resolve()
        })
      },
      onDismiss: () => {
        return new Promise(resolve => {
          resolve()
        })
      }
    }
  },
  watch: {
    type(type) {
      switch (type) {
        case 'info':
          this.heading = 'Información'
          break
        case 'warning':
          this.heading = 'Atención'
          break
        case 'error':
          this.heading = 'Error'
          break
        case 'question':
          this.heading = 'Confirmación'
          break
        default:
          this.heading = ''
          break
      }
    }
  },
  methods: {
    show(
      type,
      message,
      hasDismissButton,
      onConfirm = () => {
        return new Promise(resolve => {
          resolve()
        })
      },
      onDismiss = () => {
        return new Promise(resolve => {
          resolve()
        })
      }
    ) {
      this.type = type
      this.text = message
      this.hasDismissButton = hasDismissButton
      this.onConfirm = onConfirm
      this.onDismiss = onDismiss
      this.dialog = true
    },
    async confirm() {
      this.loading = true
      await this.onConfirm()
      this.loading = false
      this.dialog = false
    },

    async dismiss() {
      this.loading = true
      await this.onDismiss()
      this.loading = false
      this.dialog = false
    },
    close() {
      this.dialog = false
    }
  }
}
</script>
